module.exports = require("@lingui/react");